// ✅ FILE: src/components/risk-management-policy.js
import React from 'react';
import "./terms-conditions.css";

const RiskManagementPolicyComponent = () => {
  return (
    <div className="tc-container">
      <header className="tc-header mb-4">
        <h1>Risk Management Policy</h1>
        
      </header>

      <section className="tc-content mb-3">
        <h2>1. Preamble</h2>
        <p>
          1.1 Section 134(3) of the Companies Act, 2013 requires a statement to be included in the report of the 
          Board of Directors (“Board”) of <b>Singh Finlease Private Limited</b> (the “Company”), 
          indicating the development and implementation of a Risk Management Policy. This includes the 
          identification of risk elements that may threaten the existence of the Company.
        </p>
        <p>
          1.2 Accordingly, the Board of Directors adopted this policy to establish a robust 
          system for managing uncertainties. This policy is subject to periodic amendments and 
          ensures that the Company operates within its defined risk appetite.
        </p>

        <h2>2. Objectives</h2>
        <p>This Policy is designed to achieve the following objectives:</p>
        <ul>
          <li>To ensure that all current and future material risk exposures are identified, assessed, and appropriately mitigated.</li>
          <li>To establish a standard framework for the Company’s risk management process.</li>
          <li>To ensure compliance with regulatory requirements by adopting industry best practices.</li>
          <li>To facilitate sustainable business growth while maintaining financial stability.</li>
        </ul>

        <h2>3. Risk Management Framework</h2>
        <p>Our Risk Management approach consists of three primary stages:</p>

        <h5><b>A. Risk Identification</b></h5>
        <p>
          Risk Identification involves pinpointing the source or origin of potential risks. 
          Functional heads are responsible for identifying risks associated with their respective departments 
          on a regular basis. These risks are documented to ensure they do not negatively impact 
          the Company’s overall performance.
        </p>

        <h5><b>B. Risk Analysis</b></h5>
        <p>
          Once identified, risks are analyzed to determine their characteristics. A score is assigned 
          based on the potential threat to the Company and the likelihood of the threat materializing. 
          This helps in prioritizing which risks require immediate attention.
        </p>

        <h5><b>C. Risk Assessment and Control</b></h5>
        <p>
          Internal and external risk factors are assessed by the responsible functional heads and 
          reported to the Risk Management Committee. The Company deals with these risks through 
          four primary strategies:
        </p>
        <ul>
          <li><b>Avoidance:</b> Eliminating the activity that triggers the risk.</li>
          <li><b>Reduction:</b> Implementing measures to decrease the impact or likelihood.</li>
          <li><b>Retention:</b> Accepting the risk if it falls within the risk appetite.</li>
          <li><b>Transfer:</b> Moving the risk to a third party (e.g., Insurance).</li>
        </ul>

        <h2>4. Risk Management Committee</h2>
        <p>
          The Board has constituted a Risk Management Committee with the overall responsibility 
          of overseeing risk management across the Company. The key responsibilities include:
        </p>
        <ul>
          <li>Reviewing strategic risks arising from adverse business decisions.</li>
          <li>Reviewing operational, financial, reporting, and compliance risks.</li>
          <li>Discussing the Company’s risk philosophy and risk appetite.</li>
          <li>Evaluating the effectiveness of existing risk management processes.</li>
          <li>Reviewing key risk indicators (KRIs) and management response strategies.</li>
        </ul>

        <h2>5. Review and Amendment</h2>
        <p>
          The Risk Management Committee shall periodically review this Policy and recommend 
          amendments as deemed appropriate. The Board of Directors shall review the policy 
          at least once every three years to ensure its continued relevance and effectiveness.
        </p>
      </section>
    </div>
  );
};

export default RiskManagementPolicyComponent;